import React, { Component } from 'react'
import { history } from 'react-router'
import { Link } from 'react-router-dom'
import { withCookies, Cookies } from 'react-cookie'
import { LazyLoadImage } from 'react-lazy-load-image-component'

import { connect } from 'react-redux'
import * as actions from '../../Redux/reducer'

class ReportItem extends Component {
    constructor(props) {
        super(props)
    }

    render() {
        const appName = this.props.cookies.get('app_name')
        let EmptyImg = require('../../../Res/img/hausplanner_logo_gold3.png')
        if (appName && appName !== '') {
            EmptyImg = require(`../../../Res/3rd/${appName}/img/empty_img.png`)
        }

        // 날짜 변환
        const newDate = new Date(this.props.item.workDate)
        const newYear = newDate.getFullYear()
        const week = new Array('일', '월', '화', '수', '목', '금', '토')
        const newDayName = week[newDate.getDay()]

        let newMonth = newDate.getMonth() + 1
        if (newMonth < 10) {
            newMonth = '0' + newMonth
        }
        let newDay = newDate.getDate()
        if (newDay < 10) {
            newDay = '0' + newDay
        }
        let newHours = newDate.getHours()
        if (newHours < 10) {
            newHours = '0' + newHours
        }
        let newMinutes = newDate.getMinutes()
        if (newMinutes < 10) {
            newMinutes = '0' + newMinutes
        }

        let process = ''

        this.props.item.works.forEach((work) => {
            if (work.process) process += '#' + work.process.title + ' '
        })

        // 날씨
        let weatherText = ''
        let weatherIcon = ''

        if (this.props.item.weather === 'sun') {
            weatherText = '맑음'
            weatherIcon =
                '<svg xmlns="http://www.w3.org/2000/svg" width="21" height="22" viewBox="0 0 21 22">\
          <g fill="none" fillRule="evenodd" stroke="#FEBD01">\
            <path strokeWidth="1.2" d="M10.765 6.105c-2.666 0-4.839 2.196-4.839 4.896 0 2.7 2.173 4.896 4.839 4.896 2.666 0 4.839-2.195 4.839-4.896 0-2.7-2.173-4.896-4.84-4.896z"/>\
            <path strokeLinecap="round" strokeWidth=".7" d="M10.517.885c0-.124.105-.225.225-.225.124 0 .225.096.225.225v2.423a.227.227 0 0 1-.225.226.222.222 0 0 1-.225-.226V.885zM16.48 2.69a.227.227 0 0 1 .314-.05c.1.072.126.209.05.314l-1.424 1.96a.227.227 0 0 1-.315.05.222.222 0 0 1-.049-.314l1.424-1.96zm3.77 4.984a.227.227 0 0 1 .285.144.222.222 0 0 1-.145.284l-2.304.748a.227.227 0 0 1-.284-.144.222.222 0 0 1 .145-.283l2.304-.749zm.14 6.263a.227.227 0 0 1 .145.283.222.222 0 0 1-.284.144l-2.304-.749a.227.227 0 0 1-.145-.283.222.222 0 0 1 .284-.144l2.304.749zm-3.546 5.148c.073.1.048.243-.05.314a.222.222 0 0 1-.314-.05l-1.424-1.96a.227.227 0 0 1 .05-.315.222.222 0 0 1 .314.05l1.424 1.96zm-5.877 2.067a.227.227 0 0 1-.225.226.222.222 0 0 1-.225-.226v-2.423c0-.124.105-.225.225-.225.124 0 .225.095.225.225v2.423zm-5.963-1.803a.227.227 0 0 1-.314.05.222.222 0 0 1-.05-.314l1.425-1.96a.227.227 0 0 1 .314-.05c.1.072.126.209.05.314l-1.425 1.96zm-3.77-4.985a.227.227 0 0 1-.284-.144.222.222 0 0 1 .145-.283l2.304-.749a.227.227 0 0 1 .284.144.222.222 0 0 1-.145.283l-2.305.75zm-.14-6.262a.227.227 0 0 1-.144-.284.222.222 0 0 1 .283-.144l2.305.749a.227.227 0 0 1 .145.283.222.222 0 0 1-.284.144l-2.304-.748zm3.547-5.148a.227.227 0 0 1 .049-.315.222.222 0 0 1 .314.05l1.424 1.96c.074.101.049.244-.049.315a.222.222 0 0 1-.314-.05L4.64 2.953z"/>\
          </g>\
        </svg>'
        } else if (this.props.item.weather === 'cloud') {
            weatherText = '구름낌'
            weatherIcon =
                '<svg xmlns="http://www.w3.org/2000/svg" width="25" height="18" viewBox="0 0 25 18">\
          <g fill="none" fillRule="evenodd">\
            <path stroke="#B7BEC8" strokeWidth="1.2" d="M20.574 9.536c-.27 0-.54.03-.803.087-.842-1.98-2.808-3.3-4.935-3.3-2.654 0-4.86 1.897-5.3 4.532h-.019c-1.735 0-3.147 1.433-3.147 3.194s1.412 3.194 3.147 3.194h11.057c2.093 0 3.796-1.729 3.796-3.854 0-2.124-1.703-3.853-3.796-3.853z"/>\
            <g stroke="#FEBD01" strokeLinecap="round">\
              <path d="M11.492 5.45a4 4 0 0 0-5.727 5.533"/>\
              <path strokeWidth=".8" d="M9.707.973a.165.165 0 0 1 .19-.132c.09.016.15.097.133.19l-.304 1.723a.165.165 0 0 1-.19.132.161.161 0 0 1-.133-.189L9.707.973zm4.057 2.038a.165.165 0 0 1 .23.005.161.161 0 0 1-.002.23l-1.26 1.217a.165.165 0 0 1-.231-.005.161.161 0 0 1 .003-.231l1.26-1.216zM3.43 13.415a.165.165 0 0 1-.231-.005.161.161 0 0 1 .003-.23l1.26-1.217a.165.165 0 0 1 .23.005.161.161 0 0 1-.003.231l-1.26 1.216zM1.348 9.391a.165.165 0 0 1-.184-.14.161.161 0 0 1 .138-.185l1.734-.244a.165.165 0 0 1 .184.14.161.161 0 0 1-.138.185l-1.734.244zm.686-4.475a.165.165 0 0 1-.067-.22.161.161 0 0 1 .22-.07l1.547.823c.08.042.108.143.067.221a.161.161 0 0 1-.221.068l-1.546-.822zm3.193-3.215a.165.165 0 0 1 .076-.218.161.161 0 0 1 .219.074l.767 1.574c.04.08.003.18-.076.218a.161.161 0 0 1-.219-.074L5.227 1.7z"/>\
            </g>\
          </g>\
        </svg>'
        } else if (this.props.item.weather === 'gray') {
            weatherText = '흐림'
            weatherIcon =
                '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="17" viewBox="0 0 24 17">\
          <g fill="none" fillRule="evenodd" stroke="#B7BEC8" strokeWidth="1.2">\
            <path d="M19.574 8.536c-.27 0-.54.03-.803.087-.842-1.98-2.808-3.3-4.935-3.3-2.654 0-4.86 1.897-5.3 4.532h-.019c-1.735 0-3.147 1.433-3.147 3.194s1.412 3.194 3.147 3.194h11.057c2.093 0 3.796-1.729 3.796-3.854 0-2.124-1.703-3.853-3.796-3.853zM11.58 3.539C10.888 1.914 9.275.83 7.53.83c-2.18 0-3.99 1.557-4.351 3.72C1.739 4.55.58 5.726.58 7.172c0 1.445 1.159 2.621 2.583 2.621h1.24"/>\
          </g>\
        </svg>'
        } else if (this.props.item.weather === 'rain') {
            weatherText = '비'
            weatherIcon =
                '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="20" viewBox="0 0 24 20">\
          <g fill="none" fillRule="evenodd">\
            <path stroke="#B7BEC8" strokeWidth="1.2" d="M18.39 4.798c-.329 0-.657.036-.979.107C16.384 2.49 13.987.88 11.393.88 8.156.88 5.465 3.194 4.93 6.407h-.023c-2.116 0-3.837 1.747-3.837 3.895 0 2.147 1.721 3.895 3.837 3.895H18.39c2.553 0 4.63-2.109 4.63-4.7 0-2.59-2.077-4.699-4.63-4.699z"/>\
            <g stroke="#5B8BF7" strokeLinecap="round">\
              <path d="M5.833 17.125L7 19.145M10.5 17.125l1.167 2.02M15.167 17.125l1.166 2.02M19.833 17.125L21 19.145"/>\
            </g>\
          </g>\
        </svg>'
        } else if (this.props.item.weather === 'snow') {
            weatherText = '눈'
            weatherIcon =
                '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="22" viewBox="0 0 20 22">\
          <g fill="none" fillRule="evenodd" stroke="#5B8BF7" stroke:inecap="round" strokeWidth="1.1">\
            <path d="M9.976 1.154v19.692M12.988 2.419L10.01 5.397 6.964 2.35M12.988 19.581l-2.978-2.978-3.046 3.046"/>\
            <g>\
              <path d="M1.609 5.772l16.595 9.581M4.156 3.908L5.185 7.75 1.136 8.835M18.545 12.215l-3.842 1.03 1.085 4.049"/>\
            </g>\
            <g>\
              <path d="M18.273 5.766L1.678 15.347M18.614 8.904l-3.842-1.03 1.085-4.048M4.225 17.212l1.03-3.842-4.05-1.085"/>\
            </g>\
          </g>\
        </svg>'
        }

        // 투입된 인원수
        const workerNum = 0
        // if (this.props.item.works) {
        //     for (let i = 0; i < this.props.item.works.length; i++) {
        //         if (this.props.item.works[i].workers) {
        //             for (let k = 0; k < this.props.item.works[i].workers.length; k++) {
        //                 workerNum += this.props.item.works[i].workers[k].mainNum
        //                 workerNum += this.props.item.works[i].workers[k].subNum
        //             }
        //         }
        //     }
        // }

        return (
            <li
                onClick={() => {
                    this.props.onClick()
                }}>
                <Link to={{ pathname: `/report/${this.props.item._id}` }}>
                    <div className="date_wrap">
                        <div className="date">
                            {newYear}.{newMonth}.{newDay} ({newDayName})
                        </div>
                        {this.props.item.weather && this.props.item.weather !== '' && this.props.item.temperature && (
                            <ul className="weather_info">
                                {/* <li className="weather_icon" dangerouslySetInnerHTML={ {__html: weatherIcon}}></li> */}
                                <li className="weather_text">{weatherText}</li>
                                <li className="weather_low">{this.props.item.temperature.low}˚</li>
                                <li className="weather_line"></li>
                                <li className="weather_high">{this.props.item.temperature.high}˚</li>
                            </ul>
                        )}
                        {/* <div className="worker_num">
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
              <g fill="none" fillRule="evenodd" stroke="#24524A" strokeLinecap="round" strokeWidth="1.3">
              <path class="cls-2" d="M7,5.72a17.8,17.8,0,0,0,2.57-.17l.2,0a.42.42,0,0,0,.4-.4.39.39,0,0,0-.36-.39h0a2.8,2.8,0,0,0-1.55-2.5l-.12.66L8,3.67a.18.18,0,1,1-.36-.06l.16-.9L7.92,2a.34.34,0,0,0-.32-.23H6.4A.34.34,0,0,0,6.08,2l.12.73.16.9A.18.18,0,1,1,6,3.67l-.14-.79-.12-.66a2.8,2.8,0,0,0-1.55,2.5h0a.39.39,0,0,0-.36.39.42.42,0,0,0,.4.4l.2,0A17.8,17.8,0,0,0,7,5.72Z"/><path class="cls-2" d="M10.73,9.52v2.73h1.49a3.31,3.31,0,0,0-1.49-2.73Z"/><path class="cls-2" d="M9,8.86a2.25,2.25,0,0,1-2,1,2.25,2.25,0,0,1-2-1A3.93,3.93,0,0,0,4.33,9v3.24H9.67V9A3.93,3.93,0,0,0,9,8.86Z"/><path class="cls-2" d="M3.27,12.25V9.52a3.31,3.31,0,0,0-1.49,2.73Z"/><path class="cls-2" d="M9.58,5.92A18.63,18.63,0,0,1,7,6.09a18.63,18.63,0,0,1-2.58-.17A3.82,3.82,0,0,0,5,7.8a2.77,2.77,0,0,0,1.15,1,2.14,2.14,0,0,0,1.72,0A2.77,2.77,0,0,0,9,7.8a3.82,3.82,0,0,0,.57-1.88Z"/>
                </g></svg>
                {workerNum}
              </div> */}
                        <div className="view_count">
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="10" viewBox="0 0 14 10">
                                <g fill="#D9DCE2" fillRule="evenodd">
                                    <path d="M13.9 4.542C11.72 1.46 9.365-.078 6.9.003 2.914.123.198 4.385.084 4.566a.56.56 0 0 0 .013.61C2.304 8.378 4.64 10 7.047 10c.085 0 .17-.003.256-.007 3.95-.187 6.519-4.668 6.626-4.859a.559.559 0 0 0-.03-.592z" />
                                    <path
                                        stroke="#FFF"
                                        strokeWidth="1.2"
                                        d="M5 4.95C5 6.08 5.92 7 7.05 7S9.1 6.08 9.1 4.95 8.18 2.9 7.05 2.9 5 3.82 5 4.95z"
                                    />
                                </g>
                            </svg>
                            {this.props.item.viewCount}
                        </div>
                    </div>
                    <div className="thumbnail_wrap">
                        {this.props.item.dayoff && (
                            <div className="day_off_wrap">
                                <div className="day_off">휴무</div>
                            </div>
                        )}
                        <div className="thumbnail">
                            {this.props.item.thumbnailUrl ? (
                                <LazyLoadImage src={this.props.item.thumbnailUrl} />
                            ) : (
                                <img src={EmptyImg} />
                                // <svg xmlns="http://www.w3.org/2000/svg" width="66" height="56" viewBox="0 0 66 56">
                                //     <path
                                //         fill="#DADDE3"
                                //         fillRule="evenodd"
                                //         d="M63.272 20.728A3.931 3.931 0 0 1 65 23.985v28.56A2.454 2.454 0 0 1 62.549 55H3.45A2.454 2.454 0 0 1 1 52.544V23.983c0-1.305.646-2.524 1.725-3.255L30.916 1.632a3.672 3.672 0 0 1 4.117-.001l28.24 19.097zM52.882 43.78V30.47c0-1.05-.514-2.03-1.375-2.627L35.171 16.165a3.182 3.182 0 0 0-3.577-.032L14.512 27.848a3.194 3.194 0 0 0-1.422 2.658v11.31c0 1.085.878 1.964 1.96 1.964h29.138l7.863 6.926a.49.49 0 0 0 .831-.352V43.78z"
                                //     />
                                // </svg>
                            )}
                        </div>
                        {/* {this.props.item.timelapseUrl && this.props.item.dayoff === false &&
                <div className="video">
                  <LazyLoadImage src={`https://i.ytimg.com/vi/${this.props.item.timelapseUrl}/mqdefault.jpg`} />
                </div>
              } */}
                        <div className="process">
                            <p>{process}</p>
                            {this.props.item.comments.length > 0 && (
                                <div className="comment_num">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
                                        <g
                                            fill="none"
                                            fillRule="evenodd"
                                            stroke="#24524A"
                                            strokeLinecap="round"
                                            strokeWidth="1.3">
                                            <path
                                                strokeLinejoin="round"
                                                d="M1 9.3c0 .736.597 1.333 1.333 1.333h8L13 12.9V2.633c0-.736-.597-1.333-1.333-1.333H2.333C1.597 1.3 1 1.897 1 2.633V9.3z"
                                            />
                                            <path d="M10.5 4.8h-7M8.5 7.3h-5" />
                                        </g>
                                    </svg>
                                    {this.props.item.comments.length}
                                </div>
                            )}
                        </div>
                    </div>
                </Link>
            </li>
        )
    }
}

const mapStateToProps = (state) => ({
    lastClickedItemId: state.globalReducer.lastClickedItemId,
})

const mapDispatchToProps = (dispatch) => ({
    setLastClickedItemId: (lastClickedItemId) => dispatch(actions.setLastClickedItemId(lastClickedItemId)),
})
export default connect(mapStateToProps, mapDispatchToProps)(withCookies(ReportItem))



// WEBPACK FOOTER //
// ./Src/Components/Report/ReportItem.js